var _defs, _circle, _path, _ellipse, _ellipse2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmiley0Percent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 395 395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff5e4a;}.cls-2{fill:#ff514a;}.cls-3{fill:#515151;}.cls-4{fill:none;stroke:#515151;stroke-miterlimit:10;stroke-width:15px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 200.03,
    cy: 200.24,
    r: 192.5,
    transform: "translate(-85.53 197.35) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200,12.74A187.55,187.55,0,0,1,273,373a187.55,187.55,0,0,1-146-345.54,186.38,186.38,0,0,1,73-14.73m0-10C91,2.74,2.53,91.17,2.53,200.24S91,397.74,200,397.74s197.5-88.42,197.5-197.5S309.1,2.74,200,2.74Z",
    transform: "translate(-2.53 -2.74)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 121.17,
    cy: 161.24,
    rx: 37.03,
    ry: 33.58,
    transform: "translate(-82.74 169.64) rotate(-56.25)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 268,
    cy: 161.24,
    rx: 33.58,
    ry: 37.03,
    transform: "translate(-45.9 187.94) rotate(-36.43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.33,294.82s100.51-101.93,202.44,0",
    transform: "translate(-2.53 -2.74)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley0Percent);
export default __webpack_public_path__ + "static/media/smiley-0-percent.f193039c8e43e485b3a44f71d6499eb0.svg";
export { ForwardRef as ReactComponent };